import { Observable, Subject, Subscriber } from 'rxjs';

import FormFile from '../interfaces/file';
import { HttpClient } from './http-client';

export class FileService extends HttpClient {
  store(
    file: File,
    progress: Subscriber<ProgressEvent> | Subject<ProgressEvent>
  ): Observable<FormFile> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.post<FormFile>(`/api/files`, formData, {
      headers: { 'Content-Type': null },
      progressSubscriber: progress,
    });
  }

  download(id: string) {
    return this.get<Blob>(`/api/files/${id}`, {}, { responseType: 'blob' });
  }
}
